import styled from "@emotion/styled";
import { Link } from "..";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .MuiBreadcrumbs-root {
    .MuiBreadcrumbs-separator {
      color: rgba(255, 255, 255, 0.7) !important;
      font-weight: 600 !important;
      margin: 0 8px !important;
    }

    .MuiBreadcrumbs-li {
      .MuiLink-root {
        color: rgba(255, 255, 255, 0.9) !important;
        text-decoration: none !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        transition: all 0.3s ease !important;
        padding: 4px 8px !important;
        border-radius: 8px !important;

        &:hover {
          color: white !important;
          background: rgba(255, 255, 255, 0.1) !important;
        }
      }

      .MuiTypography-root {
        color: white !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        padding: 4px 8px !important;
        border-radius: 8px !important;
        background: rgba(255, 255, 255, 0.1) !important;
      }
    }
  }

  @media (max-width: 768px) {
    .MuiBreadcrumbs-root {
      .MuiBreadcrumbs-li {
        .MuiLink-root,
        .MuiTypography-root {
          font-size: 12px !important;
          padding: 2px 6px !important;
        }
      }
    }
  }
`;

const LinkTag = styled(Link)`
  color: rgba(255, 255, 255, 0.9) !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  padding: 4px 8px !important;
  border-radius: 8px !important;

  &:hover {
    color: white !important;
    background: rgba(255, 255, 255, 0.1) !important;
  }

  @media (max-width: 768px) {
    font-size: 12px !important;
    padding: 2px 6px !important;
  }
`;

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const SC = {
  Container,
  LinkTag,
  BodyHeader,
};

export default SC;
